import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Quill from 'quill';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Spinner } from '../../../../../../core/services/spinner.service';
import { CustomValidator } from '../../../../../../shared/directive/custom-validator';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { NewsService } from '../../../../../../shared/service/news.service';
const Bold = Quill.import('formats/bold');
Bold.tagName = 'b';
Quill.register(Bold, true);

const Size = Quill.import('attributors/style/size');
Size.whitelist = ['8px', '9px', '10px', '12px', '13px', '14px', '16px', '18px', '20px', '22px'];
Quill.register(Size, true);

const Font = Quill.import('formats/font');
Font.whitelist = ['GEInspiraRegular'];
Quill.register(Font, true);

@Component({
  selector: 'app-create-edit-news',
  templateUrl: './create-edit-news.component.html',
  styleUrls: ['./create-edit-news.component.scss']
})
export class CreateEditNewsComponent implements OnInit {

  @ViewChild('quillFileRef') quillFileRef: ElementRef;
  meQuillRef: any;
  // editorModules = ;

  public quill: Quill;
  public formGroup: FormGroup;
  public content: any;
  public newsId: any;
  public isEdit = false;
  public isContent = false;
  public limit = 4096;
  constructor(
    private toastr: ToastrService,
    private newsService: NewsService,
    private spinner: Spinner,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.newsId = res.id;
        this.isEdit = true;
        this.getNewsById(this.newsId);
      }
    });
  }

  ngOnInit() {
    this.initForm();
    this.initEditor();

    this.quill.on('text-change', (delta, oldDelta, source) => {
      if (this.quill.getLength() > this.limit) {
        this.quill.deleteText(this.limit, this.quill.getLength());
      }
    });
  }

  public initEditor() {
    this.quill = new Quill('#editor', {
      theme: 'snow',
      modules: {
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],

            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],

            [{ size: ['13px', '8px', '9px', '10px', '12px', '14px', '16px', '18px', '20px', '22px'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }],
            [{ font: ['GEInspiraRegular'] }],
            [{ align: [] }],

            ['clean'],

            ['link', 'image', 'video']
          ],
          handlers: {
            image: (image) => {
              this.customImageUpload(image);
            }
          }
        }
      }
    });
  }

  public initForm(model?) {
    if (!model) {
      this.formGroup = new FormGroup({
        title: new FormControl('', [CustomValidator.required]),
        shortDescription: new FormControl('', [CustomValidator.required]),
      });
    } else {
      this.formGroup = new FormGroup({
        title: new FormControl(model.title, [CustomValidator.required]),
        shortDescription: new FormControl(model.shortDescription, [CustomValidator.required]),
      });
    }
  }

  public customImageUpload(image) {
    this.quillFileRef.nativeElement.click();
  }

  getNewsById(id) {
    this.spinner.show();
    this.newsService.getNewsById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        const model = {
          title: res.data.title,
          shortDescription: res.data.description
        };
        this.initForm(model);
        this.quill.clipboard.dangerouslyPasteHTML(0, res.data.content);
      }
    });
  }

  public onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file.size > 10485760) {
        this.toastr.error(
          MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC_SIZE
        );
        return;
      }
      if (file.name.split('.')[file.name.split('.').length - 1] === 'svg') {
        this.toastr.error(
          MESSAGE_TOAST.FILE_TYPE_WRONG
        );
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      this.spinner.show();
      this.newsService.uploadImageToS3(file).subscribe((res: any) => {
        this.spinner.hide();
        if (res.data) {
          const img = `<img class="img-within" style="width:500px;height:600px;" src="${res.data.resourceUrl}"
           alt="${res.data.resourceId}"></img>`;
          const range = this.quill.getSelection();
          this.quill.clipboard.dangerouslyPasteHTML(range.index, img);
          this.quillFileRef.nativeElement.value = '';
        }
      });
    }
  }

  public submit() {
    if (this.formGroup.invalid) {
      this.markFormGroupTouched(this.formGroup);
      return;
    }
    this.content = this.quill.root.innerHTML;
    if (!this.content.trim()) {
      this.isContent = false;
      return;
    }
    this.isContent = true;
    if (!this.isEdit) {
      this.spinner.show();
      this.newsService.addNews(this.formGroup.controls.title.value, this.formGroup.controls.shortDescription.value,
        this.content).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.ADD_NEWS);
            this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_NEWS]);
          }
        });
    } else {
      this.spinner.show();
      this.newsService.updateNews(this.newsId, this.formGroup.controls.title.value, this.formGroup.controls.shortDescription.value,
        this.content)
        .subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.EDIT_NEWS);
            this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_NEWS]);
          }
        });
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
